import { render, staticRenderFns } from "./FakeVSGenuine.vue?vue&type=template&id=4e190892"
import script from "./FakeVSGenuine.vue?vue&type=script&lang=js"
export * from "./FakeVSGenuine.vue?vue&type=script&lang=js"
import style0 from "./FakeVSGenuine.vue?vue&type=style&index=0&id=4e190892&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports